import { dealQueryKeys } from '@lib/deals/hooks/deal-query-keys';
import type { QueryClient } from '@lib/query/client';

import { participantKeys } from './participant-query-keys';

/**
 * Deal-party autofill runs in a background job after a merge or upload, so
 * the participants change without any client mutation. Refresh shortly after
 * and once more to cover a slow job.
 */
export const PARTICIPANT_AUTOFILL_REFRESH_DELAYS_MS = [3_000, 10_000] as const;

/**
 * Schedules delayed participant invalidations for a flow. Uses
 * `invalidateQueries`, never `refetch()`: an uncached `refetch()` joins a
 * request that is already in flight and would return the stale result.
 */
export function scheduleParticipantAutofillRefresh(
  queryClient: QueryClient,
  target: { flowId: string; dealId?: string | null }
): void {
  // The job only fills flows that belong to a deal, so a deal-less flow has
  // nothing to refresh.
  const { flowId, dealId } = target;
  if (!dealId) return;
  for (const delayMs of PARTICIPANT_AUTOFILL_REFRESH_DELAYS_MS) {
    setTimeout(() => {
      void queryClient.invalidateQueries({
        queryKey: participantKeys.list(flowId),
      });
      void queryClient.invalidateQueries({
        queryKey: dealQueryKeys.participantsBase(dealId),
      });
    }, delayMs);
  }
}
